export const HYGRAPH_ENDPOINT = process.env.REACT_APP_HYGRAPH_ENDPOINT! ?? "";

export const HYGRAPH_ASSET_ORIGIN = process.env.REACT_APP_HYGRAPH_ASSET_ORIGIN! ?? "";
